import React from "react";
import { Link } from "react-router";

const CheckoutSuccess = () => {
    return (
        <div>
            <div>Update subscription successfully</div>
            <div style={{ marginTop: "30px" }}>
                <Link to="/" style={{ marginRight: "20px" }}>
                    Back to Home
                </Link>
            </div>
        </div>
    );
};

export default CheckoutSuccess;
